import React from 'react'

// same as on backend
export const MAX_LENGTH = 255

type Props = {
  length?: number
}

export function CharCounter({ length = 0 }: Props) {
  return <span>{`${length}/${MAX_LENGTH}`}</span>
}
